<template>
  <div
    class="gwnl-step-footer"
    :style="{width:footerWidth}"
  >
    <div class="text-right mt12 mr32">
      <slot name="right" />
      <yxt-button
        v-if="operation.cancel"
        plain
        :disabled="operation.cancelDisabled"
        :loading="operation.cancelLoading"
        @click="operation.cancel"
      >
        {{ operation.cancelName || $t('pc_gwnl_global_msg_cancel' /* 取消 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.save"
        :plain="!operation.disabled"
        :loading="operation.disabled"
        @click="operation.save"
      >
        {{ operation.saveName || $t('pc_gwnl_global_btn_save' /* 保存 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.preview"
        :plain="!operation.previewDisabled"
        :loading="operation.previewDisabled"
        @click="operation.preview"
      >
        {{ $t('pc_gwnl_global_btn_preview' /* 预览 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.withdraw"
        :plain="!operation.withdrawDisabled"
        :loading="operation.withdrawDisabled"
        @click="operation.withdraw"
      >
        {{ $t('pc_gwnl_global_btn_recall' /* 撤回 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.prev"
        :plain="!operation.prevDisabled"
        :loading="operation.prevDisabled"
        @click="operation.prev"
      >
        {{ $t('pc_gwnl_global_btn_previous' /* 上一步 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.primaryPrev"
        type="primary"
        :loading="operation.primaryPrevDisabled"
        @click="operation.primaryPrev"
      >
        {{ $t('pc_gwnl_global_btn_previous' /* 上一步 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.next"
        type="primary"
        :loading="operation.nextDisabled"
        @click="operation.next"
      >
        {{ $t('pc_gwnl_global_btn_next' /* 下一步 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.publish"
        type="primary"
        :loading="operation.publishDisabled"
        @click="operation.publish"
      >
        {{ operation.publishName || $t('pc_gwnl_global_btn_release' /* 发布 */) }}
      </yxt-button>
      <yxt-button
        v-if="operation.primarySave"
        type="primary"
        :loading="operation.primarySaveDisabled"
        @click="operation.primarySave"
      >
        {{ operation.saveText || $t('pc_gwnl_global_btn_save' /* 保存 */) }}
      </yxt-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'YxtbizEvalStepFooter',
  props: {
    operation: {
      type: Object,
      default: () => {
        return {};
      }
    },
    footerWidth: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang='scss' scoped>
.gwnl-step-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 99;
  height: 56px;
  background: #fff;
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.04);
}
</style>
